export const Common = {
  dateFormat: 'DD/MM/YYYY',
  datetimeFormat: 'DD/MM/YYYY HH:mm',
  datetime2Format: 'DD/MM/YYYY HH:mm:ss',
  dateTimePickerFormat: 'DD/MM/YYYY HH:mm',
  currency100Keys: [
    'price',
    'old_price',
    'new_price',
    'refund_amount',
    'charge_amount',
  ],
};
